import React from 'react';

function PipelineSummary({ summary }) {
  const formatCurrency = (val) => {
    if (!val && val !== 0) return '$0';
    return `$${val.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  return (
    <div className="mkt-summary">
      <div className="mkt-summary-card">
        <div className="mkt-summary-value">{summary.totalLeads || 0}</div>
        <div className="mkt-summary-label">Total Leads</div>
      </div>
      <div className="mkt-summary-card mkt-summary-alert">
        <div className="mkt-summary-value">{summary.notContacted || 0}</div>
        <div className="mkt-summary-label">Awaiting Report</div>
      </div>
      {summary.callList > 0 && (
        <div className="mkt-summary-card">
          <div className="mkt-summary-value">{summary.callList}</div>
          <div className="mkt-summary-label">Call List</div>
        </div>
      )}
      <div className="mkt-summary-card">
        <div className="mkt-summary-value">{summary.reachedCheckout || 0}</div>
        <div className="mkt-summary-label">Reached Checkout</div>
      </div>
      <div className="mkt-summary-card">
        <div className="mkt-summary-value">{summary.returningVisitors || 0}</div>
        <div className="mkt-summary-label">Returning</div>
      </div>
      <div className="mkt-summary-card mkt-summary-success">
        <div className="mkt-summary-value">{summary.paid || 0}</div>
        <div className="mkt-summary-label">Paid</div>
      </div>
      <div className="mkt-summary-card mkt-summary-success">
        <div className="mkt-summary-value">{formatCurrency(summary.revenue)}</div>
        <div className="mkt-summary-label">Revenue</div>
      </div>
      <div className="mkt-summary-card">
        <div className="mkt-summary-value">{summary.conversionRate || 0}%</div>
        <div className="mkt-summary-label">Lead Conversion</div>
        <div className="mkt-summary-sub">
          paid, of {summary.totalLeads || 0} people who gave their details
        </div>
      </div>
    </div>
  );
}

export default PipelineSummary;
